import { render } from "./stage_4.vue?vue&type=template&id=922372b6"
const script = {}

import exportComponent from "/home/ec2-user/src/FVC.frontend/Public/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__